import React from 'react'
import { withProps } from 'recompose'
import Svg from '../../../../../shared/Svg'

const FirstHome = withProps(() => ({
  viewBox: '0 0 1000 1000',
  children: (
    <>
      <path d='M915 550l-114-86V275h14c8 0 15-7 15-16s-7-16-15-16H644c-8 0-15 7-15 16s7 16 15 16h14v82L508 245c-4-3-11-3-15 0L85 551c-4 2-6 7-7 12 0 4 1 9 4 13l32 50v353c0 9 6 16 14 16h745c8 0 14-7 14-16V626l30-51c3-3 5-8 4-13 0-5-2-10-6-12zM687 275h86v168l-86-64V275zM572 962H429V717c0-45 32-82 72-82 39 0 71 37 71 82v245zm286 0H601V717c0-63-45-114-100-114-28 0-53 12-71 33s-30 49-30 81v245H143V628l358-268 357 268v334zm13-364L508 327c-4-3-11-3-15 0L130 598l-18-28 389-291 388 290-18 29zM735 203c37 0 109-92 109-128 0-27-17-52-42-62-25-9-53-2-71 18a63 63 0 0 0-71-18 66 66 0 0 0-41 62c0 36 80 128 116 128zM683 42c18 0 32 15 32 33v4c0 10 7 17 16 17s16-7 16-17v-4c0-18 15-33 32-33 18 0 32 15 32 33 0 21-62 97-80 99-18-2-80-78-80-99 0-18 14-33 32-33z' />
      <path d='M787 639H670c-8 0-14 7-14 15v127c0 9 6 16 14 16h117c8 0 15-7 15-16V655c0-9-6-16-15-16zm-8 132h-97V666h97v105zM327 639H210c-8 0-15 7-15 15v127c0 9 7 16 15 16h117c8 0 14-7 14-16V655c1-9-6-16-14-16zm-9 132h-96V666h96v105z' />
    </>
  )
}))(Svg)

export default FirstHome
